import React from 'react';

import Chip from "@mui/joy/Chip";
import Link from "@mui/joy/Link";

// components
import CommonInfoTab from "../Common/CommonInfoTab";

// icons
import WebIcon from '@mui/icons-material/Web';


class WikiPageCard extends React.Component {
    render() {
        if (this.props.mini){
            return (
                <Chip
                    startDecorator={<WebIcon />}
                >
                    <Link
                        href={'/wiki_page/detail/'+this.props.wikiPage.id}
                        target={'_blank'}
                        fontSize={'small'}
                    >
                        {this.props.wikiPage.title.slice(0, 50)}
                    </Link>
                </Chip>
            )
        }
        return(
            <CommonInfoTab
                groups={
                    [
                        {
                            title: this.props.wikiPage.title,
                            icon: <WebIcon />,
                            linkPattern: '/wiki_page/detail/:linkParam',
                            linkParam: this.props.wikiPage.id,
                            flat: true,
                            fields: [
                                {
                                    title: 'Описание',
                                    value: this.props.wikiPage.content.slice(0, 200),
                                    html: true,
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                },
                            ]
                        }
                    ]
                }
            />
        )
    }
}

export default WikiPageCard
